// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lower_cont {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 10px;
}

.button_list {
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 1em;
}

.inv {
  display: flex;
  flex-direction: row;
  gap: 1em;
  opacity: 50%;
}

.samp_filter_block {
  flex-grow: 1;
  display: flex;
  justify-content: space-between;
}

.samp_filter_block_left {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
}

.samp_filter_item {
  padding: 10px;
  flex-basis: calc(20% - 10px);
}

.request-date-wrapper {
  display: flex;
  flex-direction: column;
  align-items: end;
  margin: 0;
  gap: 0.8em;
}

.period-wrapper {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  align-items: baseline;
  gap: 1.1em;
}

.period_nom_wrapper {
  padding-top: 10px;
  padding-left: 10px;
}

.period_nom {
  width: max-content;
  margin-bottom: 5px;
}

.border {
  width: 100%;
  border: 1px solid #a3b9d9;
}
.border_gap {
  margin-top: 10px;
  margin-bottom: 10px;
}
.border_gap2 {
  margin-top: 1em;
  margin-bottom: 1em;
}

.upper_part_s {
  display: flex;
  flex-direction: row;
}

.upper_buttons {
  margin-top: 1em;
  display: grid;
  gap: 1em;
  grid-template: repeat(3, 1fr)/repeat(3, 1fr);
}

.upper_btn_item {
  flex-basis: 35%;
}
.upper_btn_item:nth-child(3) {
  grid-column: span 3;
}

.middle_buttons {
  display: flex;
  flex-direction: row;
  justify-content: end;
  gap: 1em;
}

.samp_filter_block_two {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
}

.samp_filter_item_two {
  padding: 10px;
  flex-basis: calc(20% - 10px);
}

.samp_filter_area_row {
  display: flex;
  flex: 1 1;
  justify-content: space-between;
}
.samp_filter_area_row div {
  flex-grow: 1;
}`, "",{"version":3,"sources":["webpack://./src/Components/SamplesList/samples.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;AACF;;AAGA;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AAAF;;AAGA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;AAAF;;AAGA;EACE,YAAA;EACA,aAAA;EAEA,8BAAA;AADF;;AAMA;EACE,aAAA;EACA,eAAA;EACA,8BAAA;EACA,mBAAA;AAHF;;AAMA;EACE,aAAA;EACA,4BAAA;AAHF;;AAMA;EACE,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,SAAA;EACA,UAAA;AAHF;;AAKA;EACE,aAAA;EACA,sBAAA;EACA,iBAAA;EACA,qBAAA;EACA,UAAA;AAFF;;AAKA;EACE,iBAAA;EACA,kBAAA;AAFF;;AAKA;EACE,kBAAA;EACA,kBAAA;AAFF;;AAKA;EACE,WAAA;EACA,yBAAA;AAFF;AAGE;EACE,gBAAA;EACA,mBAAA;AADJ;AAIE;EACE,eAAA;EACA,kBAAA;AAFJ;;AAMA;EACE,aAAA;EACA,mBAAA;AAHF;;AAOA;EAME,eAAA;EACA,aAAA;EACA,QAAA;EAEA,4CAAA;AAVF;;AAeA;EACE,eAAA;AAZF;AAcE;EACE,mBAAA;AAZJ;;AAgBA;EACE,aAAA;EACA,mBAAA;EACA,oBAAA;EACA,QAAA;AAbF;;AAgBA;EACE,aAAA;EACA,eAAA;EACA,8BAAA;EACA,mBAAA;AAbF;;AAiBA;EACE,aAAA;EACA,4BAAA;AAdF;;AAiBA;EACE,aAAA;EACA,SAAA;EACA,8BAAA;AAdF;AAgBE;EACE,YAAA;AAdJ","sourcesContent":[".lower_cont {\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  margin-bottom: 10px;\n  // margin-top: 10px;\n}\n\n.button_list {\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  gap: 1em;\n}\n\n.inv {\n  display: flex;\n  flex-direction: row;\n  gap: 1em;\n  opacity: 50%;\n}\n\n.samp_filter_block {\n  flex-grow: 1;\n  display: flex;\n  // flex-wrap: wrap;\n  justify-content: space-between;\n  // align-items: center;\n  // margin-bottom: 1em;\n}\n\n.samp_filter_block_left {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.samp_filter_item {\n  padding: 10px;\n  flex-basis: calc(20% - 10px);\n}\n\n.request-date-wrapper {\n  display: flex;\n  flex-direction: column;\n  align-items: end;\n  margin: 0;\n  gap: 0.8em;\n}\n.period-wrapper {\n  display: flex;\n  flex-direction: column;\n  flex-wrap: nowrap;\n  align-items: baseline;\n  gap: 1.1em;\n}\n\n.period_nom_wrapper {\n  padding-top: 10px;\n  padding-left: 10px;\n}\n\n.period_nom {\n  width: max-content;\n  margin-bottom: 5px;\n}\n\n.border {\n  width: 100%;\n  border: 1px solid #a3b9d9;\n  &_gap {\n    margin-top: 10px;\n    margin-bottom: 10px;\n  }\n\n  &_gap2 {\n    margin-top: 1em;\n    margin-bottom: 1em;\n  }\n}\n\n.upper_part_s {\n  display: flex;\n  flex-direction: row;\n  // margin-bottom: 15px;\n}\n\n.upper_buttons {\n  // display: flex;\n  // flex-direction: column;\n  // gap: 1em;\n  // margin-left: 10px;\n  // flex-grow: 1;\n  margin-top: 1em;\n  display: grid;\n  gap: 1em;\n  // grid-template-areas: \"add . edit\" \". view .\" \"dubl . del\";\n  grid-template: repeat(3, 1fr) / repeat(3, 1fr);\n  // grid-template-columns: repeat(2, 1fr);\n  // grid-template-rows: repeat(3, 1fr);\n}\n\n.upper_btn_item {\n  flex-basis: calc(35%);\n\n  &:nth-child(3) {\n    grid-column: span 3;\n  }\n}\n\n.middle_buttons {\n  display: flex;\n  flex-direction: row;\n  justify-content: end;\n  gap: 1em;\n}\n\n.samp_filter_block_two {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  align-items: center;\n  // margin-bottom: 1em;\n}\n\n.samp_filter_item_two {\n  padding: 10px;\n  flex-basis: calc(20% - 10px);\n}\n\n.samp_filter_area_row {\n  display: flex;\n  flex: 1;\n  justify-content: space-between;\n\n  & div {\n    flex-grow: 1;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
